import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.intake');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import * as QRCode from 'qrcode';

@Component({
    selector: 'wiz-page-intake',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.intake/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.intake-shell {
  position: relative;
  min-height: 100%;
  background: radial-gradient(circle at top left, rgba(16, 185, 129, 0.08), transparent 28%), linear-gradient(180deg, #f7faf9 0%, #eef4f4 100%);
}

.intake-shell-bg {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(148, 163, 184, 0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(148, 163, 184, 0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.22), transparent 70%);
  pointer-events: none;
}

.intake-container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 24px 16px 40px;
}

.intake-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
  margin-bottom: 16px;
}

.intake-hero-main,
.intake-hero-side,
.intake-step-card,
.intake-submit-card,
.intake-side-card,
.intake-complete-hero,
.intake-summary-card {
  border: 1px solid #d7e2e0;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 20px 50px -40px rgba(15, 23, 42, 0.3);
}

.intake-hero-main {
  padding: 24px;
}

.intake-hero-side {
  padding: 18px;
}

.intake-hero-badges,
.intake-hero-points,
.intake-submit-row,
.intake-summary-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.intake-badge,
.intake-point,
.intake-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 12px;
  border: 1px solid #bfdbd2;
  background: #e9fbf4;
  font-size: 11px;
  font-weight: 700;
  color: #0f766e;
}

.intake-badge--soft,
.intake-point,
.intake-pill {
  background: #f8fafc;
  border-color: #d7e0ea;
  color: #475569;
}

.intake-pill--done {
  background: #ecfdf3;
  border-color: #a7f3d0;
  color: #047857;
}

.intake-hero-title {
  margin-top: 14px;
  font-size: 32px;
  line-height: 1.15;
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #0f172a;
}

.intake-hero-sub {
  margin-top: 10px;
  max-width: 760px;
  font-size: 15px;
  line-height: 1.65;
  color: #475569;
}

.intake-hero-points {
  margin-top: 16px;
}

.intake-progress-title,
.intake-side-title {
  font-size: 13px;
  font-weight: 800;
  color: #0f172a;
}

.intake-progress-meta {
  margin-top: 4px;
  font-size: 11px;
  color: #64748b;
}

.intake-progress-bar {
  margin-top: 12px;
  height: 10px;
  overflow: hidden;
  background: #e2e8f0;
}

.intake-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #0f766e 0%, #10b981 100%);
}

.intake-progress-list,
.intake-guide-list {
  margin-top: 12px;
  display: grid;
  gap: 8px;
}

.intake-progress-item,
.intake-side-row,
.intake-guide-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 10px 0;
  border-bottom: 1px solid #eef2f7;
  font-size: 11px;
  color: #475569;
}

.intake-progress-item:last-child,
.intake-side-row:last-child,
.intake-guide-item:last-child {
  border-bottom: 0;
}

.intake-progress-item strong,
.intake-side-row strong {
  font-weight: 800;
  color: #0f172a;
}

.intake-progress-item--done strong {
  color: #047857;
}

.intake-alert {
  margin-bottom: 16px;
  border: 1px solid #fecdd3;
  background: #fff1f2;
  padding: 12px 14px;
  font-size: 12px;
  line-height: 1.5;
  color: #be123c;
}

.intake-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
  align-items: start;
}

.intake-form-column,
.intake-side-column {
  min-width: 0;
}

.intake-form-column {
  display: grid;
  gap: 14px;
}

.intake-step-card,
.intake-submit-card,
.intake-side-card,
.intake-summary-card {
  padding: 18px;
}

.intake-side-card--soft {
  background: rgba(248, 250, 252, 0.96);
}

.intake-side-column {
  position: sticky;
  top: 16px;
  display: grid;
  gap: 12px;
}

.intake-step-head {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 16px;
}

.intake-step-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: 1px solid #99f6e4;
  background: #ecfeff;
  font-size: 12px;
  font-weight: 800;
  color: #0f766e;
  flex-shrink: 0;
}

.intake-step-title {
  font-size: 18px;
  font-weight: 800;
  color: #0f172a;
}

.intake-step-sub,
.intake-inline-note,
.intake-submit-note,
.intake-side-divider,
.intake-qr-caption,
.intake-complete-sub,
.intake-next-step,
.intake-summary-text--muted {
  font-size: 12px;
  line-height: 1.6;
  color: #64748b;
}

.intake-step-sub {
  margin-top: 4px;
}

.intake-field-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.intake-field-stack {
  display: grid;
  gap: 12px;
}

.intake-field,
.intake-quick-item {
  min-width: 0;
}

.intake-label,
.intake-ticket-label {
  display: block;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #475569;
}

.intake-input,
.intake-textarea {
  min-height: 44px;
  border-radius: 0 !important;
  font-size: 14px;
}

.intake-textarea {
  min-height: auto;
}

.intake-inline-note {
  margin-top: 10px;
}

.intake-visit-type-block {
  margin-top: 16px;
}

.intake-visit-type-grid,
.intake-quick-grid,
.intake-ticket-grid {
  display: grid;
  gap: 10px;
}

.intake-visit-type-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.intake-visit-chip {
  display: flex;
  min-height: 84px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  border: 1px solid #d7e0ea;
  background: #f8fafc;
  padding: 14px;
  text-align: left;
  transition: background-color 0.15s, border-color 0.15s, color 0.15s;
}

.intake-visit-chip strong {
  font-size: 14px;
  font-weight: 800;
  color: #0f172a;
}

.intake-visit-chip span {
  font-size: 11px;
  line-height: 1.45;
  color: #64748b;
}

.intake-visit-chip--active {
  border-color: #10b981;
  background: #ecfdf5;
}

.intake-quick-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.intake-consent {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.65;
  color: #475569;
}

.intake-consent-check {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.intake-submit-row {
  margin-top: 14px;
  justify-content: space-between;
}

.intake-submit-btn {
  min-width: 180px;
}

.intake-side-summary {
  margin-top: 10px;
}

.intake-side-divider {
  margin: 12px 0 0;
  padding-top: 12px;
  border-top: 1px solid #e2e8f0;
}

.intake-guide-item {
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 0;
}

.intake-pill-list {
  margin-top: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.intake-complete-layout {
  display: grid;
  gap: 14px;
}

.intake-complete-hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 16px;
  padding: 22px;
  border-color: #bbf7d0;
  background: linear-gradient(180deg, #f0fdf4 0%, #ffffff 100%);
}

.intake-complete-kicker {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #047857;
}

.intake-complete-title {
  margin-top: 8px;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 800;
  color: #0f172a;
}

.intake-complete-sub {
  margin-top: 8px;
}

.intake-ticket-grid {
  margin-top: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.intake-ticket-card,
.intake-qr-card {
  border: 1px solid #d7e0ea;
  background: #ffffff;
}

.intake-ticket-card {
  padding: 14px;
}

.intake-ticket-value {
  display: block;
  margin-top: 6px;
  font-size: 24px;
  line-height: 1;
  font-weight: 800;
  color: #0f172a;
}

.intake-next-steps {
  margin-top: 16px;
  display: grid;
  gap: 8px;
}

.intake-complete-qr {
  display: flex;
  align-items: center;
  justify-content: center;
}

.intake-qr-card {
  width: 100%;
  padding: 14px;
  text-align: center;
}

.intake-qr-image {
  width: 100%;
  max-width: 220px;
  margin: 0 auto;
}

.intake-qr-caption {
  margin-top: 10px;
}

.intake-summary-complaint {
  margin-top: 14px;
}

.intake-summary-text {
  font-size: 13px;
  line-height: 1.65;
  color: #0f172a;
}

@media (max-width: 1023px) {
  .intake-hero,
  .intake-layout,
  .intake-complete-hero {
    grid-template-columns: minmax(0, 1fr);
  }
  .intake-side-column {
    position: static;
  }
}
@media (max-width: 767px) {
  .intake-container {
    padding: 16px 12px 28px;
  }
  .intake-hero-main,
  .intake-hero-side,
  .intake-step-card,
  .intake-submit-card,
  .intake-side-card,
  .intake-complete-hero,
  .intake-summary-card {
    padding: 14px;
  }
  .intake-hero-title {
    font-size: 24px;
  }
  .intake-field-grid,
  .intake-quick-grid,
  .intake-ticket-grid,
  .intake-visit-type-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .intake-submit-row,
  .intake-summary-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .intake-submit-btn {
    width: 100%;
    min-width: 0;
  }
  .intake-step-head {
    gap: 10px;
  }
  .intake-complete-title {
    font-size: 22px;
  }
}`],
})
export class PageIntakeComponent implements OnInit {
    public loading: boolean = false;
    public submitted: boolean = false;
    public errorMessage: string = '';
    public intake: any = null;
    public accessKey: string = '';
    public source: string = 'link';
    public resultUrl: string = '';
    public resultQr: string = '';
    public form: any = {
        name: '',
        phone: '',
        birth_date: '',
        gender: '',
        visit_type: 'outpatient',
        chief_complaint: '',
        symptom_duration: '',
        symptom_details: '',
        cold_heat: '',
        sleep: '',
        appetite: '',
        digestion: '',
        stool: '',
        urine: '',
        pain_area: '',
        past_history: '',
        allergies: '',
        current_medications: '',
        pregnancy: '',
        additional_note: '',
        consent_privacy: false,
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.accessKey = WizRoute.segment.accessKey || '';
        const params = new URLSearchParams(location.search);
        this.source = params.get('source') || (this.accessKey ? 'resume' : 'link');

        if (this.accessKey) {
            await this.loadExisting();
        }

        await this.service.render();
    }

    private async loadExisting() {
        const { code, data } = await wiz.call('bootstrap', { access_key: this.accessKey });
        if (code !== 200) {
            this.errorMessage = data?.message || '예진 정보를 찾을 수 없습니다.';
            return;
        }

        this.intake = data.intake || null;
        if (!this.intake) return;

        this.form = this.mapIntakeToForm(this.intake);
        this.submitted = true;
        this.resultUrl = this.buildResultUrl(this.intake.access_key);
        await this.generateQr(this.resultUrl);
    }

    private mapIntakeToForm(intake: any) {
        const payload = intake?.payload || {};
        return {
            name: intake?.name || '',
            phone: intake?.phone || '',
            birth_date: intake?.birth_date || '',
            gender: intake?.gender || '',
            visit_type: intake?.visit_type || 'outpatient',
            chief_complaint: intake?.chief_complaint || '',
            symptom_duration: payload?.symptom_duration || '',
            symptom_details: payload?.symptom_details || '',
            cold_heat: payload?.cold_heat || '',
            sleep: payload?.sleep || '',
            appetite: payload?.appetite || '',
            digestion: payload?.digestion || '',
            stool: payload?.stool || '',
            urine: payload?.urine || '',
            pain_area: payload?.pain_area || '',
            past_history: payload?.past_history || '',
            allergies: payload?.allergies || '',
            current_medications: payload?.current_medications || '',
            pregnancy: payload?.pregnancy || '',
            additional_note: payload?.additional_note || '',
            consent_privacy: true,
        };
    }

    private buildResultUrl(accessKey: string) {
        return `${location.origin}/intake/${accessKey}`;
    }

    private async generateQr(url: string) {
        try {
            this.resultQr = await QRCode.toDataURL(url, {
                width: 220,
                margin: 1,
                color: {
                    dark: '#0f172a',
                    light: '#ffffff',
                },
            });
        } catch {
            this.resultQr = '';
        }
    }

    public hasIdentityValue() {
        return !!this.form.name;
    }

    public hasContactValue() {
        return !!(this.form.phone || this.form.birth_date);
    }

    public hasChiefComplaint() {
        return !!this.form.chief_complaint;
    }

    public hasConsent() {
        return !!this.form.consent_privacy;
    }

    public completionCount() {
        let count = 0;
        if (this.hasIdentityValue()) count += 1;
        if (this.hasContactValue()) count += 1;
        if (this.hasChiefComplaint()) count += 1;
        if (this.hasConsent()) count += 1;
        return count;
    }

    public completionPercent() {
        return Math.round((this.completionCount() / 4) * 100);
    }

    public getVisitTypeLabel(type?: string) {
        const map: any = {
            outpatient: '초진',
            revisit: '재진',
            emergency: '응급',
        };
        return map[type || this.form.visit_type] || '초진';
    }

    public getSourceDescription() {
        const map: any = {
            qr: '병원 안내 QR을 통해 접속한 예진입니다.',
            link: '안내 링크로 접속한 예진입니다.',
            sms: '문자 링크를 통해 접속한 예진입니다.',
            resume: '기존에 작성한 예진 내용을 다시 확인하는 화면입니다.',
        };
        return map[this.source] || '병원 접수 전에 작성하는 예진입니다.';
    }

    public getContactSummary() {
        return this.form.phone || this.form.birth_date || '연락처 또는 생년월일을 남겨주세요';
    }

    public getSubmittedContactSummary() {
        if (!this.intake) return '-';
        return this.intake.phone || this.intake.birth_date || '-';
    }

    public hasBodySignal() {
        return !!(this.form.cold_heat || this.form.sleep || this.form.appetite || this.form.digestion || this.form.stool || this.form.urine);
    }

    public hasSafetyNote() {
        return !!(this.form.past_history || this.form.allergies || this.form.current_medications || this.form.pregnancy || this.form.additional_note);
    }

    public async submit() {
        this.errorMessage = '';
        if (!this.form.name) {
            this.errorMessage = '이름을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (!this.form.phone && !this.form.birth_date) {
            this.errorMessage = '연락처 또는 생년월일 중 하나를 입력해주세요.';
            await this.service.render();
            return;
        }
        if (!this.form.chief_complaint) {
            this.errorMessage = '현재 증상을 입력해주세요.';
            await this.service.render();
            return;
        }
        if (!this.form.consent_privacy) {
            this.errorMessage = '예진 데이터 처리 동의가 필요합니다.';
            await this.service.render();
            return;
        }

        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('submit', {
            ...this.form,
            source: this.source,
            consent_privacy: String(!!this.form.consent_privacy),
        });

        this.loading = false;

        if (code !== 200) {
            this.errorMessage = data?.message || '예진 제출에 실패했습니다.';
            await this.service.render();
            return;
        }

        this.service.href(`/intake/${data.intake.access_key}`);
    }

    public async copyResultUrl() {
        if (!this.resultUrl) return;
        try {
            await navigator.clipboard.writeText(this.resultUrl);
            await this.service.modal.show({ title: '복사 완료', message: '예진 결과 링크를 복사했습니다.', action: '확인' });
        } catch {
            await this.service.modal.show({ title: '복사 실패', message: '브라우저에서 복사를 허용하지 않았습니다.', action: '확인' });
        }
    }

    public getSourceLabel() {
        const map: any = {
            qr: '대표 QR',
            link: '홈페이지 링크',
            sms: '문자 링크',
            resume: '기존 예진',
        };
        return map[this.source] || '예진 링크';
    }

    public startNew() {
        this.service.href('/intake');
    }
}

export default PageIntakeComponent;